<div *ngIf="isLoading$ | async" class="overlay-spinner">
  <p-progressSpinner ariaLabel="loading" />
</div>
